import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { translate } from "../../../i18n";
import { EventDto } from "../../../models/event/dto/event.dto";
import { useSelectedLocation } from "../../location-management/hooks/useSelectedLocation";
import { GET_EVENT_QUERY_KEY } from "./useGetEvent";
import { GET_EVENTS_QUERY_KEY } from "./useListEvents";

export const useCancelEvent = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();
    const { selectedLocation } = useSelectedLocation();

    return useMutation({
        mutationKey: ['cancelEvent'],
        mutationFn: (eventId: number) =>
            client.fetchApi<{ success: boolean; message: string; event: EventDto }, {}>({
                endpoint: `events/${eventId}`,
                method: 'DELETE'
            }),
        onSuccess: (data, eventId) => {
            queryClient.invalidateQueries({ queryKey: GET_EVENT_QUERY_KEY(eventId) });
            queryClient.invalidateQueries({ queryKey: GET_EVENTS_QUERY_KEY(selectedLocation?.id, 'future') });
            queryClient.invalidateQueries({ queryKey: GET_EVENTS_QUERY_KEY(selectedLocation?.id, 'past') });
            toast({
                title: translate('event.cancel_success'),
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
        },
        onError: (error: any) => {
            toast({
                title: translate('event.cancel_error'),
                description: error?.message,
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
